/**
 * Page panier (/cart) : quantités +/- et suppression en AJAX, sous-total / total mis à jour.
 */
(function () {
  const root = document.querySelector("[data-cart-page-root]");
  if (!root) return;

  const FREE_THRESHOLD_CENTS = 4500;
  const SHIPPING_COST_CENTS = 690;

  const shopCurrency =
    (typeof window !== "undefined" &&
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active) ||
    "EUR";

  const formatMoney = (cents) =>
    (Number(cents) / 100).toLocaleString("fr-FR", {
      style: "currency",
      currency: shopCurrency,
    });

  const linesEl = root.querySelector("[data-cart-page-lines]");
  /** Hero est hors du conteneur grid (bandeau) : sélecteur global. */
  const heroCountEl = document.querySelector("[data-cart-page-hero]");
  const subtotalEl = root.querySelector("[data-cart-page-subtotal]");
  const shippingEl = root.querySelector("[data-cart-page-shipping]");
  const totalEl = root.querySelector("[data-cart-page-total]");
  const freeMsgEl = root.querySelector("[data-cart-page-free-msg]");

  const escapeHtml = (str) => {
    if (str == null) return "";
    const d = document.createElement("div");
    d.textContent = String(str);
    return d.innerHTML;
  };

  const fetchCart = () =>
    fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => {
      if (!r.ok) throw new Error("cart.js");
      return r.json();
    });

  const changeLine = async (line, quantity) => {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg =
        data.description ||
        data.message ||
        (Array.isArray(data.errors) ? data.errors.join(" ") : null) ||
        "Impossible de mettre à jour le panier.";
      throw new Error(msg);
    }
    return data;
  };

  const closestEl = (ev, selector) => {
    const t = ev.target;
    if (t instanceof Element) return t.closest(selector);
    if (t && t.parentElement) return t.parentElement.closest(selector);
    return null;
  };

  const updateSummary = (cart) => {
    const sub = cart.items_subtotal_price ?? 0;
    const shipCents = sub >= FREE_THRESHOLD_CENTS ? 0 : SHIPPING_COST_CENTS;
    const total = sub + shipCents;

    if (subtotalEl) subtotalEl.textContent = formatMoney(sub);
    if (shippingEl) {
      shippingEl.textContent = shipCents === 0 ? "Gratuit" : formatMoney(SHIPPING_COST_CENTS);
    }
    if (totalEl) totalEl.textContent = formatMoney(total);

    if (freeMsgEl) {
      if (sub > 0 && sub < FREE_THRESHOLD_CENTS) {
        freeMsgEl.hidden = false;
        freeMsgEl.textContent = `Plus que ${formatMoney(FREE_THRESHOLD_CENTS - sub)} pour la livraison gratuite !`;
      } else {
        freeMsgEl.hidden = true;
      }
    }

    if (heroCountEl) {
      const n = cart.item_count ?? 0;
      heroCountEl.textContent = `${n} article${n !== 1 ? "s" : ""} dans votre panier`;
    }
  };

  const renderLineHtml = (item, index) => {
    const line = item.line != null ? item.line : index + 1;
    const variant =
      item.variant_title && item.variant_title !== "Default Title"
        ? `<p class="font-outfit text-xs sm:text-sm text-muted-foreground mt-1 m-0">${escapeHtml(item.variant_title)}</p>`
        : "";
    const img = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="" width="96" height="96" class="w-full h-full object-cover" loading="lazy" />`
      : `<span class="font-outfit text-xs text-muted-foreground p-2 text-center">Sans image</span>`;
    const title = escapeHtml(item.product_title || item.title || "");
    const url = escapeHtml(item.url || "#");

    return `
      <div class="bg-card rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-soft border border-border/50 flex gap-3 sm:gap-4" data-cart-line>
        <a href="${url}" class="shrink-0 w-16 h-16 sm:w-24 sm:h-24 rounded-lg sm:rounded-xl bg-muted overflow-hidden flex items-center justify-center">${img}</a>
        <div class="flex-1 min-w-0">
          <h3 class="font-roxborough text-base sm:text-lg text-foreground m-0">
            <a href="${url}" class="hover:text-primary transition-colors">${title}</a>
          </h3>
          ${variant}
          <p class="font-buffalo text-lg sm:text-xl text-primary mt-1 sm:mt-2 m-0">${formatMoney(item.price)}</p>
        </div>
        <div class="flex flex-col items-end justify-between shrink-0 gap-2">
          <button type="button" class="p-1.5 sm:p-2 rounded-full hover:bg-red-50 transition-colors text-red-500 inline-flex" data-cart-page-remove data-line="${line}" aria-label="Retirer du panier">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
            </svg>
          </button>
          <div class="flex items-center gap-1 sm:gap-2 bg-muted rounded-full p-0.5">
            <button type="button" class="p-1.5 sm:p-2 hover:bg-background rounded-full transition-colors inline-flex" data-cart-page-qty-dec data-line="${line}" aria-label="Diminuer la quantité">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"></path></svg>
            </button>
            <input type="number" min="0" max="9999" inputmode="numeric" value="${item.quantity}" data-line="${line}" data-cart-page-qty-input class="cart-page__line-qty w-10 sm:w-12 min-w-0 max-w-[3.5rem] text-center font-outfit font-medium text-sm tabular-nums text-foreground bg-transparent border-0 p-0 m-0 [appearance:textfield] [-moz-appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none focus:ring-0" aria-label="Quantité" />
            <button type="button" class="p-1.5 sm:p-2 hover:bg-background rounded-full transition-colors inline-flex" data-cart-page-qty-inc data-line="${line}" aria-label="Augmenter la quantité">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>
            </button>
          </div>
        </div>
      </div>`;
  };

  const renderLines = (cart) => {
    if (!linesEl || !cart.items || cart.items.length === 0) return;
    linesEl.innerHTML = cart.items.map((item, i) => renderLineHtml(item, i)).join("");
  };

  const syncHeaderBadge = async () => {
    try {
      const cart = await fetchCart();
      const badge = document.querySelector("[data-cart-header-badge]");
      const n = cart.item_count || 0;
      const label = n <= 0 ? "" : n > 99 ? "99+" : String(n);
      if (badge) {
        badge.textContent = label;
        badge.classList.toggle("hidden", n <= 0);
        badge.setAttribute("aria-hidden", n <= 0 ? "true" : "false");
      }
    } catch {
      /* ignore */
    }
  };

  const applyCart = async (cart) => {
    if (!cart.item_count) {
      window.location.reload();
      return;
    }
    renderLines(cart);
    updateSummary(cart);
    if (window.themeCartDrawer && typeof window.themeCartDrawer.refresh === "function") {
      void window.themeCartDrawer.refresh();
    } else {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
    await syncHeaderBadge();
  };

  const applyLineQty = async (line, qty) => {
    await changeLine(line, qty);
    const cart = await fetchCart();
    await applyCart(cart);
  };

  root.addEventListener("click", async (e) => {
    const inc = closestEl(e, "[data-cart-page-qty-inc]");
    const dec = closestEl(e, "[data-cart-page-qty-dec]");
    const rem = closestEl(e, "[data-cart-page-remove]");
    const lineEl = inc || dec || rem;
    if (!lineEl) return;

    const line = Number(lineEl.getAttribute("data-line"));
    if (!line) return;

    e.preventDefault();
    e.stopPropagation();

    let qty;
    if (rem) {
      qty = 0;
    } else {
      const row = lineEl.closest("[data-cart-line]");
      const qtyInput = row?.querySelector("input.cart-page__line-qty");
      const raw = qtyInput?.value?.trim() ?? "";
      const parsed = parseInt(raw, 10);
      const current = Number.isNaN(parsed) ? 1 : Math.max(0, parsed);
      qty = inc ? current + 1 : Math.max(0, current - 1);
    }

    try {
      await applyLineQty(line, qty);
    } catch (err) {
      window.alert(err instanceof Error ? err.message : String(err));
      try {
        const cart = await fetchCart();
        await applyCart(cart);
      } catch {
        window.location.reload();
      }
    }
  });

  root.addEventListener("change", async (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement) || !t.classList.contains("cart-page__line-qty")) return;
    const line = Number(t.getAttribute("data-line"));
    if (!line) return;
    const raw = t.value.trim();
    if (raw === "") {
      try {
        const cart = await fetchCart();
        await applyCart(cart);
      } catch {
        window.location.reload();
      }
      return;
    }
    const qty = parseInt(raw, 10);
    if (Number.isNaN(qty)) {
      try {
        const cart = await fetchCart();
        await applyCart(cart);
      } catch {
        window.location.reload();
      }
      return;
    }
    const clamped = Math.max(0, Math.min(9999, qty));
    try {
      await applyLineQty(line, clamped);
    } catch (err) {
      window.alert(err instanceof Error ? err.message : String(err));
      try {
        const cart = await fetchCart();
        await applyCart(cart);
      } catch {
        window.location.reload();
      }
    }
  });

  root.addEventListener("keydown", (e) => {
    if (e.key !== "Enter") return;
    const t = e.target;
    if (!(t instanceof HTMLInputElement) || !t.classList.contains("cart-page__line-qty")) return;
    e.preventDefault();
    t.blur();
  });
})();
